import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../index.css";
import "./PhotographyPageStyles.css"
import LetteredMedia from "../../components/LetteredMedia/LetteredMedia";
import LabeledMedia from "../../components/LabeledMedia/LabeledMedia";
import CoverTitle from "../../components/CoverTitle/CoverTitle";
import MediaService from "../../services/mediaService";

function PhotographyPage
() {
  const [heroImage, setHeroImage] = useState("/photo-assets/wedding/wedding-still.webp")
  const [modelsCoverUrl, setModelsCoverUrl] = useState("/photo-assets/p-models/OFW-female-22.jpg");
  const [portraitsCoverUrl, setPortraitsCoverUrl] = useState("/photo-assets/p-models/fountain-portrait.jpg");
  const navigate = useNavigate();


  useEffect(() => {
    const handleAspectRatio = () => {
      if (window.innerWidth > window.innerHeight) {
        // Horizontal (landscape) aspect ratio
        setHeroImage("/photo-assets/wedding/wedding-still.webp");
      }
    };

    handleAspectRatio();
    window.addEventListener('resize', handleAspectRatio);

    return () => window.removeEventListener('resize', handleAspectRatio);
  }, []);

  // Load media URLs from cloud service
  useEffect(() => {
    const loadCoverImages = async () => {
      try {
        // Load hero image
        const heroUrl = await MediaService.getMediaUrl('photography', 'wedding', 'wedding-still', {
          width: 1920,
          quality: 80
        });
        setHeroImage(heroUrl);

        // Load cover images
        const modelsUrl = await MediaService.getMediaUrl('photography', 'p-models', 'OFW-female-22', {
          width: 1024,
          quality: 80
        });
        setModelsCoverUrl(modelsUrl);

        const portraitsUrl = await MediaService.getMediaUrl('photography', 'p-models', 'fountain-portrait', {
          width: 1024,
          quality: 80
        });
        setPortraitsCoverUrl(portraitsUrl);
      } catch (error) {
        console.log('Using local fallback images');
        // Fallback to local images on error
      }
    };

    loadCoverImages();
  }, []);

  const handleCategoryClick = (categoryName) => {
    navigate(`/gallery/photography/${categoryName}`);
  };

  return (
    <div className="film-page-container flex-column-centered">
      <LetteredMedia title="Photography" src={heroImage}  bgColor="bg-dark-blue" titleColor="clr-dark-red"/>
      <LabeledMedia 
        class_Name="desktop-margin-bottom-6" 
        labelComponent={<CoverTitle clr={"clr-dark-blue"} class_Name={`title1`} title="Models" textShadow={'text-shadow-dark-2'}/>} 
        src={modelsCoverUrl} 
        alt="A model in a gray dress with one arm on the hip and a serious expression."
        onClick={() => handleCategoryClick('Models')}
      />
      <LabeledMedia 
        class_Name="desktop-margin-bottom-6" 
        labelComponent={<h2 className={"clr-dark-blue text-shadow-dark-2 real-estate-title"}>Portraits</h2>} 
        src={portraitsCoverUrl} 
        alt="A portrait photograph"
        onClick={() => handleCategoryClick('Portraits')}
      />
    </div>
  );
}

export default PhotographyPage
;
